










































import { Component, Prop, Vue } from "vue-property-decorator";
import NavBar from "../components/NavBar.vue";
import Action from "../store/actionTypes";
import TransactionSummary from "../components/TransactionSummary.vue";
import AccountSummary from "../components/AccountSummary.vue";
import PaymentInformation from "../components/PaymentInformation.vue";
import TransactionPlans from "../components/TransactionPlans.vue";
import { Statement } from "../store/user";
import Getter from "../store/getters";

@Component({
  components: {
    NavBar,
    TransactionSummary,
    AccountSummary,
    PaymentInformation,
    TransactionPlans
  }
})
export default class Login extends Vue {
  private loaded = false;
  // @ts-ignore
  private statement: Statement = {};
  created() {
    this.$store
      .dispatch(Action.FETCH_CURRENT_STATEMENT)
      .then(response => {
        this.statement = this.$store.getters[Getter.STATEMENT]();
        console.log(this.statement.transaction_plans);
      })
      .catch(() => {
        this.$store.dispatch(Action.LOGOUT).finally(() => {
          this.$router.push({
            path: "login"
          });
        });
      });
  }
}
